import { HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { InvestmentPlanPreSubscriptionContractSynthesisResponseDTO } from '@backend/dto';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class InvestmentPlanPreSubscriptionContractSynthesisRequest extends Request<
  never,
  InvestmentPlanPreSubscriptionContractSynthesisResponseDTO
> {
  constructor(options?: RequestOptions<never>) {
    super({
      ...options,
      path: `/broad${options?.version ?? '/v1'}/users/me/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/pre_Subscription_Contract_Synthesis`
    });
  }

  public execute(): Observable<InvestmentPlanPreSubscriptionContractSynthesisResponseDTO> {
    return super
      .execute()
      .pipe(
        map(
          (response: HttpResponse<InvestmentPlanPreSubscriptionContractSynthesisResponseDTO>) =>
            response.body
        )
      );
  }
}

export function getInvestmentPlanPreSubscriptionContractSynthesis(
  options?: RequestOptions<never>
): InvestmentPlanPreSubscriptionContractSynthesisRequest {
  return new InvestmentPlanPreSubscriptionContractSynthesisRequest(options);
}
